
import './style/TopHeader.css';
;

function TopHeader(props) {


  return (
      <header className="navbar-header">
        <h3>{props.name}</h3>
      </header>

  );
}

export default TopHeader;